import { Branding } from '@toolpad/core';
import { ReactRouterAppProvider } from '@toolpad/core/react-router';
import { NotificationsProvider } from '@toolpad/core/useNotifications';
import { noop } from 'lodash';
import React from 'react';
import { Outlet } from 'react-router';
import { Stack } from '@mui/system';

import { LogoHorizontal, Spinner } from '@barboxx/admin-components';
import { useAuth } from '@barboxx/admin-utils';

import { NAVIGATION } from '../areas/Admin/navigation';
import theme from './theme';

const BRANDING: Branding = {
    title: '',
    logo: <LogoHorizontal height={30} />,
    homeUrl: '/',
};

export function BarBoxxRoutes(): React.ReactElement {
    const { initializing, logout, auth } = useAuth();

    return (
        <ReactRouterAppProvider
            theme={theme}
            navigation={NAVIGATION}
            branding={BRANDING}
            authentication={{
                signIn: noop,
                signOut: logout,
            }}
            session={{
                user: auth.user
                    ? {
                          id: `${auth.user?.id}`,
                          image: auth.user?.avatar,
                          name: auth.user?.fullName,
                      }
                    : undefined,
            }}
        >
            <NotificationsProvider
                slotProps={{
                    snackbar: {
                        autoHideDuration: 3000,
                        anchorOrigin: {
                            vertical: 'bottom',
                            horizontal: 'right',
                        },
                    },
                }}
            >
                {initializing ? (
                    <Stack
                        justifyContent="center"
                        alignItems="center"
                        height="100%"
                    >
                        <Spinner />
                    </Stack>
                ) : (
                    <Outlet />
                )}
            </NotificationsProvider>
        </ReactRouterAppProvider>
    );
}
